import { Building2, ChevronRight, LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@crm/ui';
import type { Schemas } from '@crm/contracts';

export function TenantPicker({ me, onPick, onLogout }: { me: Schemas['Me']; onPick: (id: string) => void; onLogout: () => void }) {
  const { t } = useTranslation();
  const memberships = me.memberships.filter((m) => m.status === 'ACTIVE');
  return (
    <div className="grid min-h-full place-items-center bg-gradient-to-br from-[#0b2647] via-brand to-[#1d4f8c] p-4">
      <div className="w-full max-w-lg overflow-hidden rounded-2xl bg-white shadow-2xl">
        <div className="flex h-20 items-center justify-center border-b-4 border-accent">
          <img src="/logo-produit.svg" alt="CRM Agro" className="h-12" />
        </div>
        <div className="p-6">
          <h1 className="font-heading text-xl font-bold text-brand">{t('picker.title')}</h1>
          <p className="mt-1 text-sm text-slate-500">{memberships.length ? t('picker.subtitle') : t('picker.none')}</p>
          <ul className="mt-5 space-y-2">
            {memberships.map((m) => (
              <li key={m.tenant_id}>
                <button
                  onClick={() => onPick(m.tenant_id)}
                  className="flex w-full items-center gap-3 rounded-xl border border-slate-200 px-4 py-3 text-left transition hover:border-brand hover:bg-slate-50"
                  data-testid={`pick-${m.tenant_code}`}
                >
                  {m.theme.logo_url ? (
                    <img src={m.theme.logo_url} alt="" className="h-10 w-10 rounded-md object-contain" />
                  ) : (
                    <span className="grid h-10 w-10 place-items-center rounded-md text-white" style={{ background: m.theme.primary_color ?? '#103561' }}>
                      <Building2 size={18} />
                    </span>
                  )}
                  <span className="flex-1">
                    <span className="block font-semibold text-slate-900">{m.tenant_name}</span>
                    <span className="block text-xs text-slate-500">{m.role_name}</span>
                  </span>
                  <ChevronRight size={18} className="text-slate-400" />
                </button>
              </li>
            ))}
          </ul>
          <Button variant="ghost" className="mt-6 text-slate-600" onClick={onLogout}>
            <LogOut size={16} /> {t('header.logout')}
          </Button>
        </div>
      </div>
    </div>
  );
}
